import { useGetBanks } from '../api/get-banks';

export function useBanksList() {
  const { data: banks = { data: [], totalCount: 0 }, isLoading } =
    useGetBanks();

  // inserted check to avoid errors, api return is currently 200,
  // with message error and totalCount: Nan
  if (!banks.totalCount) {
    banks.data = [];
  }

  const banksOptions = banks?.data?.map(bank => ({
    key: bank.codigo,
    text: `${bank.codigo} - ${bank.nome}`,
    value: bank.nome,
  }));

  return { banks, banksOptions, isLoading };
}
